import React from "react";
import Button from "../Button/Button.js";

class SubmitButton extends React.Component {
 constructor(props) {
  super(props);
  // FOR NOW ITS A WRAPPER FOR STYLES ONLY
 }
 render() {
  return(
      <div>
            <Button {...this.props}>
              {this.props.children}
            </Button>
     </div>
  )
 }
}

export default SubmitButton;
